<template>
  <div class="ll-license-list-card">
    <div class="ll-license-list-card__title">
      <p class="title">
        {{ name }}
      </p>
    </div>
    <p
      v-if="itemList.length === 0"
      class="pa-20"
    >
      {{ emptyText }}
    </p>
    <div
      v-for="(item,itemIndex) in itemList"
      :key="itemIndex"
      class="ll-license-list-card__subtitle"
    >
      <p>
        {{ item.name }}<span>{{ `(${item.list.length})` }}</span>
      </p>
      <ListCard
        v-for="(subject,subjectIndex) in item.list"
        :key="subjectIndex"
        is-table
        no-padding
        has-border-bottom
        class="pb-20 mt-0"
        white
      >
        <ListCardItem
          is-table
          row
          type="text"
          :title="$t('名稱')"
          :text-content="subject.name"
          :isloading="isloading"
        />
        <ListCardItem
          is-table
          row
          type="text"
          :title="$t('持有人')"
          :text-content="subject.taker"
          :isloading="isloading"
        />
        <ListCardItem
          is-table
          row
          type="text"
          :title="$t('核准函號')"
          :text-content="subject.approvalLetter"
          :isloading="isloading"
        />
        <ListCardItem
          is-table
          row
          type="text"
          :title="$t('證號')"
          :text-content="subject.licenseNumber"
          :isloading="isloading"
        />
        <ListCardItem
          is-table
          row
          type="valid-date"
          :title="$t('有效起迄')"
          :valid-start="subject.validStartDate"
          :valid-end="subject.validEndDate"
          :isloading="isloading"
        />
        <ListCardItem
          is-table
          row
          type="text"
          :title="$t('證照狀態')"
          :text-content="subject.status"
          :isloading="isloading"
        />
      </ListCard>
    </div>
  </div>
</template>
<script>
export default {
  name: "LlLicenseListCard",
  props: {
    isloading: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    itemList: {
      type: Array,
      default() {
        return [];
      },
    },
    emptyText: {
      type: String,
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-license-list-card.scss";
</style>